import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DatePickerModule } from 'primeng/datepicker';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-step-principal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    DatePickerModule,
    ButtonModule
  ],
  templateUrl: './step-principal.component.html'
})
export class StepPrincipalComponent {
  @Input() formGroup!: FormGroup;
  @Input() supplierOptions: { label: string; value: number }[] = [];
  @Output() requestNewSupplier = new EventEmitter<void>();

  isFieldInvalid(fieldName: string): boolean {
    const field = this.formGroup.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  getAccessKeyError(): string {
    const field = this.formGroup.get('accessKey');
    if (!field?.errors) return 'Chave é obrigatória';
    if (field.errors['minlength'] || field.errors['maxlength']) return 'Chave deve ter exatamente 44 dígitos';
    return 'Chave é obrigatória';
  }
}
